import React, { useState } from 'react';
import cx from 'classnames';
import Banner from '../../components/Banner';
import Card from '../../components/Card';
import PaymentTitleInfo from '../PaymentTitleInfo';
import PaymentInfo from '../PaymentInfo';
import { useStateContext } from '../../context/StateContext';
import { Payment, Overview, Result } from '../../steps';
import { SECTION_HEADERS } from '../../utils/constants';
import style from './fast-payment.module.scss';

const FastPayment = ({ resultId }) => {
	const { state: { isMobile } } = useStateContext();
	const [showResult, setShowResult] = useState(resultId);

	const doPayment = () => {
		// todo bu func iyzico ödemesi harici ödemeler için yazılacak.
	};

	if (showResult) {
		return (
			<>
				<PaymentTitleInfo containerClass={isMobile && style.titleInfo} />
				<Card className={style.resultContainer}>
					<Result onRedirect={() => setShowResult(false)} />
				</Card>
			</>
		);
	}

	return (
		<>
			<PaymentTitleInfo containerClass={isMobile && style.titleInfo} />
			<div className={style.childrenContainer}>
				<div className={style.childrenContent}>
					<Card customContentClass={style.content} title={SECTION_HEADERS.PAYMENT_INFO}>
						<Overview isFastPay />
					</Card>
					<Card className={style.container} customContentClass={cx(style.content, style.paymentStep)} title={SECTION_HEADERS.PAYMENT_OPTIONS}>
						<Payment />
					</Card>
					<PaymentInfo onContinueClick={doPayment} />
				</div>
				<Banner />
			</div>
		</>
	);
};

export default FastPayment;
